import React, { useContext } from 'react'

import { PanelDeControlContext } from '../../../context/PanelDeControlContext';
import EventoSeleccionado from './EventoSeleccionado';

import style from './style.module.css'
import SearchAsistente from './SearchAsistente';

const PanelDeInformacion = () => {

    const { eventoSeleccionado } = useContext( PanelDeControlContext )

    return (
        <div className={ style.panelInformacion }>

            <SearchAsistente />     

            { !eventoSeleccionado && <p>Selecciona un evento para obtener más información</p>}
            { eventoSeleccionado && <EventoSeleccionado evento={eventoSeleccionado} />}
        </div>
    )
}

export default PanelDeInformacion
